export default "__VITE_ASSET__CtUTWWYz__"